import { BenefitSchedule } from "../domain/BenefitSchedule";

export enum Illness {
    ALZHEIMERS_DISEASE = 'Alzheimers Disease',
    AMYOTROPHIC_LATERAL_SCLEROSIS = 'Amyotrophic Lateral Sclerosis',
    BENIGN_BRAIN_TUMOR = 'Benign Brain Tumor',
    BIPOLAR_ONE_DISORDER = 'Bipolar One Disorder',
    CARCINOMA_IN_SITU = 'Carcinoma In Situ',
    CEREBRAL_PALSY = 'Cerebral Palsy',
    CLEFT_LIP_PALATE = 'Cleft Lip Palate',
    COMPLICATIONS_OF_PREGNANCY = 'Complications Of Pregnancy',
    CORONARY_ARTERY_DISEASE = 'Coronary Artery Disease',
    CORONAVIRUS = 'Coronavirus',
    COVID_19 = 'Covid 19',
    CRITICAL_ILLNESS_COMA = 'Critical Illness Coma',
    CRITICAL_ILLNESS_LOSS_OF_HEARING = 'Critical Illness Loss Of Hearing',
    CRITICAL_ILLNESS_LOSS_OF_SIGHT = 'Critical Illness Loss Of Sight',
    CRITICAL_ILLNESS_LOSS_OF_SPEECH = 'Critical Illness Loss Of Speech',
    CYSTIC_FIBROSIS = 'Cystic Fibrosis',
    DIPHTHERIA = 'Diphtheria',
    DOWN_SYNDROME = 'Down Syndrome',
    ENCEPHALITIS = 'Encephalitis',
    HEART_ATTACK = 'Heart Attack',
    INFERTILITY = 'Infertility',
    INVASIVE_CANCER = 'Invasive Cancer',
    LEGIONNAIRES_DISEASE = 'Legionnaires Disease',
    LYME_DISEASE = 'Lyme Disease',
    MAJOR_ORGAN_FAILURE = 'Major Organ Failure',
    MALARIA = 'Malaria',
    MENINGITIS = 'Meningitis',
    METHICILLIN_RESISTANT_STAPHYLOCOCCUS_AUREUS = 'Methicillin Resistant Staphylococcus Aureus',
    MULTIPLE_SCLEROSIS = 'Multiple Sclerosis',
    MUSCULAR_DYSTROPHY = 'Muscular Dystrophy',
    NECROTIZING_FASCIITIS = 'Necrotizing Fasciitis',
    OCCUPATIONAL_INFECTIOUS_DISEASE = 'Occupational Infectious Disease',
    OSTEOMYELITIS = 'Osteomyelitis',
    PARALYSIS = 'Paralysis',
    PARKINSONS_DISEASE = 'Parkinsons Disease',
    POLIOMYELITIS = 'Poliomyelitis',
    POST_TRAUMATIC_STRESS_DISORDER = 'Post Traumatic Stress Disorder',
    RABIES = 'Rabies',
    SCHIZOPHRENIA = 'Schizophrenia',
    SEPSIS = 'Sepsis',
    SKIN_CANCER = 'Skin Cancer',
    SPINA_BIFIDA = 'Spina Bifida',
    STROKE = 'Stroke',
    TETANUS = 'Tetanus',
    TUBERCULOSIS = 'Tuberculosis',
}

export function getDefaultBenefitSchedules(): BenefitSchedule[] {
    return [
        { type: Illness.ALZHEIMERS_DISEASE, isChildhoodOnlyCondition: false},
        { type: Illness.AMYOTROPHIC_LATERAL_SCLEROSIS, isChildhoodOnlyCondition: false},
        { type: Illness.BENIGN_BRAIN_TUMOR, isChildhoodOnlyCondition: false},
        { type: Illness.BIPOLAR_ONE_DISORDER, isChildhoodOnlyCondition: false},
        { type: Illness.CARCINOMA_IN_SITU, isChildhoodOnlyCondition: false},
        { type: Illness.CEREBRAL_PALSY, isChildhoodOnlyCondition: true},
        { type: Illness.CLEFT_LIP_PALATE, isChildhoodOnlyCondition: true},
        { type: Illness.COMPLICATIONS_OF_PREGNANCY, isChildhoodOnlyCondition: false},
        { type: Illness.CORONARY_ARTERY_DISEASE, isChildhoodOnlyCondition: false},
        { type: Illness.CORONAVIRUS, isChildhoodOnlyCondition: false},
        { type: Illness.COVID_19, isChildhoodOnlyCondition: false},
        { type: Illness.CRITICAL_ILLNESS_COMA, isChildhoodOnlyCondition: false},
        { type: Illness.CRITICAL_ILLNESS_LOSS_OF_HEARING, isChildhoodOnlyCondition: false},
        { type: Illness.CRITICAL_ILLNESS_LOSS_OF_SIGHT, isChildhoodOnlyCondition: false},
        { type: Illness.CRITICAL_ILLNESS_LOSS_OF_SPEECH, isChildhoodOnlyCondition: false},
        { type: Illness.CYSTIC_FIBROSIS, isChildhoodOnlyCondition: true},
        { type: Illness.DIPHTHERIA, isChildhoodOnlyCondition: false},
        { type: Illness.DOWN_SYNDROME, isChildhoodOnlyCondition: true},
        { type: Illness.ENCEPHALITIS, isChildhoodOnlyCondition: false},
        { type: Illness.HEART_ATTACK, isChildhoodOnlyCondition: false},
        { type: Illness.INFERTILITY, isChildhoodOnlyCondition: false},
        { type: Illness.INVASIVE_CANCER, isChildhoodOnlyCondition: false},
        { type: Illness.LEGIONNAIRES_DISEASE, isChildhoodOnlyCondition: false},
        { type: Illness.LYME_DISEASE, isChildhoodOnlyCondition: false},
        { type: Illness.MAJOR_ORGAN_FAILURE, isChildhoodOnlyCondition: false},
        { type: Illness.MALARIA, isChildhoodOnlyCondition: false},
        { type: Illness.MENINGITIS, isChildhoodOnlyCondition: false},
        { type: Illness.METHICILLIN_RESISTANT_STAPHYLOCOCCUS_AUREUS, isChildhoodOnlyCondition: false},
        { type: Illness.MULTIPLE_SCLEROSIS, isChildhoodOnlyCondition: false},
        { type: Illness.MUSCULAR_DYSTROPHY, isChildhoodOnlyCondition: true},
        { type: Illness.NECROTIZING_FASCIITIS, isChildhoodOnlyCondition: false},
        { type: Illness.OCCUPATIONAL_INFECTIOUS_DISEASE, isChildhoodOnlyCondition: false},
        { type: Illness.OSTEOMYELITIS, isChildhoodOnlyCondition: false},
        { type: Illness.PARALYSIS, isChildhoodOnlyCondition: false},
        { type: Illness.PARKINSONS_DISEASE, isChildhoodOnlyCondition: false},
        { type: Illness.POLIOMYELITIS, isChildhoodOnlyCondition: false},
        { type: Illness.POST_TRAUMATIC_STRESS_DISORDER, isChildhoodOnlyCondition: false},
        { type: Illness.RABIES, isChildhoodOnlyCondition: false},
        { type: Illness.SCHIZOPHRENIA, isChildhoodOnlyCondition: false},
        { type: Illness.SEPSIS, isChildhoodOnlyCondition: false},
        { type: Illness.SKIN_CANCER, isChildhoodOnlyCondition: false},
        { type: Illness.SPINA_BIFIDA, isChildhoodOnlyCondition: true},
        { type: Illness.STROKE, isChildhoodOnlyCondition: false},
        { type: Illness.TETANUS, isChildhoodOnlyCondition: false},
        { type: Illness.TUBERCULOSIS, isChildhoodOnlyCondition: false}
    ]
}